import "core-js/modules/es.function.name.js";
import { getDictCategory, getDictFixInfo, addDictFixInfo, editDictFixInfo, getFirstDictFixInfo } from '@/services/basicDataMgr.js';
var rowSelection = {
  onChange: function onChange(selectedRowKeys, selectedRows) {},
  onSelect: function onSelect(record, selected, selectedRows) {},
  onSelectAll: function onSelectAll(selected, selectedRows, changeRows) {}
};
export default {
  data: function data() {
    var _this = this;
    return {
      dictCategory: [],
      data: [],
      rowSelection: rowSelection,
      expandedRowKeys: [],
      column: [{
        title: '字典类型',
        dataIndex: 'category',
        key: 'category',
        width: 100
      }, {
        title: '字典名称',
        dataIndex: 'name',
        key: 'name',
        width: 100
      }, {
        title: '状态',
        dataIndex: 'status',
        scopedSlots: {
          customRender: 'status'
        },
        key: 'status',
        width: 100
      }, {
        title: '操作',
        key: 'action',
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        className: 'repalceColor',
        width: 100
      }],
      addView: false,
      searchForm: {
        categoryId: undefined,
        name: '',
        status: 3,
        pageSize: 10,
        pageCurrent: 1
      },
      total: 0,
      addForm: {
        categoryId: undefined,
        name: '',
        sort: '',
        describe: '',
        status: 1,
        parentId: '',
        treeLevel: ''
      },
      editForm: {
        id: '',
        categoryId: undefined,
        name: '',
        sortNum: '',
        describe: '',
        status: ''
      },
      editView: false,
      isView: false,
      editTitle: '',
      statusOne: false,
      statusSecond: false,
      firstDictData: [],
      pagination: {
        defaultPageSize: 10,
        showSizeChanger: true,
        total: 10,
        pageSizeOptions: ['10', '20', '30', '40'],
        showTotal: function showTotal(total) {
          return "\u5171 ".concat(total, " \u6761\u6570\u636E");
        },
        onShowSizeChange: function onShowSizeChange(current, pageSize) {
          return _this.pageSize = pageSize;
        }
      }
    };
  },
  mounted: function mounted() {
    this.initDictCategory();
    this.searchData();
  },
  methods: {
    handleAdd: function handleAdd() {
      this.addView = true;
    },
    initDictCategory: function initDictCategory() {
      var that = this;
      getDictCategory().then(function (res) {
        if (res.data.code == 200) {
          that.dictCategory = res.data.data;
        }
      });
    },
    searchData: function searchData() {
      var that = this;
      getDictFixInfo(that.searchForm).then(function (res) {
        if (res.data.code == 200) {
          that.data = res.data.records;
          that.pagination.total = res.data.total;
        }
      });
    },
    handleDict: function handleDict(scope, val) {
      if (val == 1) {
        //查看
        this.editForm.categoryId = scope.cateId;
        this.editForm.name = scope.name;
        this.editForm.sortNum = scope.sortNum;
        this.editForm.describe = scope.describe;
        this.editForm.status = scope.status;
        this.editTitle = '查看';
        this.isView = true;
        this.editView = true;
      } else {
        //编辑
        this.editForm.categoryId = scope.cateId;
        this.editForm.name = scope.name;
        this.editForm.sortNum = scope.sortNum;
        this.editForm.describe = scope.describe;
        this.editForm.status = scope.status;
        this.editForm.id = scope.id;
        this.editTitle = '编辑';
        this.isView = false;
        this.editView = true;
      }
    },
    onCloseEditClick: function onCloseEditClick() {
      this.editForm = {
        id: '',
        categoryId: undefined,
        name: '',
        sortNum: '',
        describe: '',
        status: ''
      };
      this.editView = false;
    },
    addClick: function addClick() {
      var _this2 = this;
      // this.form = this.$addform.createForm(this, {
      // 	name: 'validate_other'
      // });
      // this.form.validateFields((err, values) => {
      // 	if (!err) {
      // 		console.log('Received values of form: ', values);
      // 	}
      // });
      if (this.addForm.parentId != '' && this.addForm.parentId != null) {
        this.addForm.treeLevel = 2;
      } else {
        this.addForm.treeLevel = 1;
      }
      addDictFixInfo(this.addForm).then(function (res) {
        if (res.data.code == 200) {
          _this2.$message.success('添加成功！');
          _this2.addView = false;
          _this2.searchData();
        }
        _this2.addView = false;
        _this2.addForm = {
          categoryId: undefined,
          name: '',
          sort: '',
          dec: '',
          status: 1,
          parentId: ''
        };
      });
    },
    editClick: function editClick() {
      var _this3 = this;
      var that = this;
      editDictFixInfo(this.editForm).then(function (res) {
        if (res.data.code == 200) {
          _this3.$message.success('修改成功！');
          that.editView = false;
          that.searchData();
        }
      });
    },
    onChange: function onChange() {
      if (this.statusOne == true && this.statusSecond == true) {
        this.searchForm.status = 3;
      } else if (this.statusOne == true) {
        this.searchForm.status = 1;
      } else if (this.statusSecond == true) {
        this.searchForm.status = 2;
      } else if (this.statusOne == false && this.statusSecond == false) {
        this.searchForm.status = 3;
      }
    },
    getDictSelect: function getDictSelect() {
      //返回一级字典
      var that = this;
      getFirstDictFixInfo(this.addForm.categoryId).then(function (res) {
        that.firstDictData = res.data.data;
      });
    },
    onCloseAddClick: function onCloseAddClick() {
      //关闭add
      this.addForm = {
        categoryId: undefined,
        name: '',
        sort: '',
        dec: '',
        status: 1,
        parentId: ''
      };
      this.addView = false;
    },
    pageSizeChange: function pageSizeChange(val, pageNum) {
      this.loading = true;
      this.pagination.pageSize = pageNum;
      this.pagination.current = 1;
      this.searchForm.pageSize = this.pagination.pageSize;
      this.searchForm.pageCurrent = this.pagination.current;
      this.searchData(); //获取列表数据
    },
    pageChange: function pageChange(page, val) {
      this.loading = true;
      this.pagination.current = page;
      this.searchForm.pageSize = this.pagination.pageSize;
      this.searchForm.pageCurrent = this.pagination.current;
      this.searchData(); //获取列表数据
    }
  }
};